/*
 * This file is part of glowingblue/gamilytics.
 *
 * Copyright (c) 2023 Glowing Blue AG.
 * Authors: Rafael Horvat.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import Model from 'flarum/common/Model';
import FakeDiscussion from '../../../common/models/FakeDiscussion';
export default class LevelHistory extends Model {
  level() {
    return Model.attribute('level').call(this);
  }
  revision() {
    return Model.attribute('revision').call(this);
  }

  // Core groups notifications by their subject discussion, so level-change notifications need a
  // stand-in.
  discussion() {
    return new FakeDiscussion();
  }
}
flarum.reg.add('glowingblue-gamilytics', 'forum/levels/models/LevelHistory', LevelHistory);